const getArrayPages = (totalElements, size) => {
  const maxPages = Math.ceil(totalElements / size);

  return [...Array(maxPages).keys()];
};

export default getArrayPages;
